import supabase from "../../supabaseClient.js";

interface church {
  body: string;
  churchName: string;
  user: string;
}

export class AxiosWidgetChurch {
  dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  async uploadProfileImage(
    file: string,
    filePath: string
  ): Promise<number | null> {
    const blob = this.dataURLtoBlob(file);
    var bucketName = "tanyapendeta bucket";
    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);
      console.log("what".concat(filePath));
      console.log(exists);
      if (exists) {
        const { error: removeError, data: hi } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);

        if (removeError) {
          console.error("Error deleting existing file:", removeError);
          return null;
        } else {
          const { data, error } = await supabase.storage
            .from(bucketName)
            .upload(filePath, blob, { cacheControl: "3600", upsert: false });

          if (error) {
            console.error("Error uploading image:", error);
            return null;
          }

          return 200;
        }
      } else {
        const { data, error } = await supabase.storage
          .from(bucketName)
          .upload(filePath, blob, { cacheControl: "3600", upsert: false });

        if (error) {
          console.error("Error uploading image:", error);
          return null;
        }

        return 200;
      }
    } catch (err) {
      console.error("An unexpected error occurred:", err);
      return null;
    }
  }

  public async getChurch(user: string) {
    const { data, error } = await (supabase as any)
      .from("church")
      .select("*")
      .eq("personCreate", user);

    if (error) {
      console.error("Error fetching question:", error.message);
      return { error: error.message };
    }

    return { data };
  }

  async uploadChurchImage(
    file: string,
    churchName: string,
    personCreate: string,
    fileName: string
  ): Promise<{ success?: boolean; imageUrl?: string; error?: string }> {
    const blob = this.dataURLtoBlob(file);
    var bucketName = "tanyapendeta bucket";

    // Create file path with _church suffix

    const filePath = `church_images/${fileName}`;

    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);

      console.log("Checking if file exists:", filePath);
      console.log("File exists:", exists);

      if (exists) {
        const { error: removeError } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);

        if (removeError) {
          console.error("Error deleting existing file:", removeError);
          return { error: removeError.message };
        }
      }

      const { data, error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, blob, { cacheControl: "3600", upsert: true });

      if (error) {
        console.error("Error uploading church image:", error);
        return { error: error.message };
      }

      // Return the public URL
      const {
        data: { publicUrl },
      } = supabase.storage.from(bucketName).getPublicUrl(filePath);

      return { success: true, imageUrl: publicUrl };
    } catch (err) {
      console.error("An unexpected error occurred:", err);
      return { error: "An unexpected error occurred" };
    }
  }

  async uploadChurchLogo(
    file: string,
    churchName: string,
    personCreate: string,
    fileName: string
  ): Promise<{ success?: boolean; imageUrl?: string; error?: string }> {
    const blob = this.dataURLtoBlob(file); // should carry image/svg+xml from data URL
    const bucketName = "tanyapendeta bucket";
    const filePath = `church_logos/${fileName}`;

    try {
      // Direct upsert without HEAD/exists
      const { error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, blob, {
          cacheControl: "3600",
          upsert: true,
          contentType: "image/svg+xml",
        });

      if (error) {
        console.error("Error uploading church logo:", error);
        return { error: error.message };
      }

      const {
        data: { publicUrl },
      } = supabase.storage.from(bucketName).getPublicUrl(filePath);

      return { success: true, imageUrl: publicUrl };
    } catch (err) {
      console.error("An unexpected error occurred (logo):", err);
      return { error: "An unexpected error occurred" };
    }
  }

  public async createChurch(question: {
    name: string;
    introduction: string;
    personCreate: string;
    fileName: string; // main image file name
    logoFileName?: string; // optional logo file name
  }) {
    const basePayload: any = {
      name: question.name,
      introduction: question.introduction,
      personCreate: question.personCreate,
      imagesName: question.fileName,
    };

    if (question.logoFileName) {
      basePayload.logoName = question.logoFileName;
    }

    let { data, error } = await (supabase as any)
      .from("church")
      .insert(basePayload);

    if (error && question.logoFileName) {
      console.warn(
        "Insert with logoName failed, retrying without logoName:",
        error.message
      );
      const retryPayload = { ...basePayload };
      delete (retryPayload as any).logoName;
      const retry = await (supabase as any).from("church").insert(retryPayload);
      data = retry.data;
      error = retry.error;
    }

    if (error) {
      console.error("Error creating church:", error.message);
      return { error: error.message };
    }

    return { data };
  }

  public async updateQuestion(question: { id: number; question: string }) {
    const { data, error } = await (supabase as any)
      .from("ProfileQuestion")
      .update({
        body: question.question,
      })
      .eq("id", question.id);

    if (error) {
      console.error("Error updating question:", error.message);

      throw error;
    }

    return data;
  }

  /**
   * Updates church name and/or introduction
   * If name changes, also updates all Posts where churchName matches the old name
   * Also updates the image name format: {personCreate}_{churchName}_church.jpg
   */
  public async updateChurch(
    oldChurchName: string,
    newChurchName: string,
    introduction: string
  ): Promise<{ success: boolean; error?: string }> {
    try {
      // First, get the current church data to access personCreate and imagesName
      const { data: churchData, error: fetchError } = await (supabase as any)
        .from("church")
        .select("personCreate, imagesName")
        .eq("name", oldChurchName)
        .maybeSingle();

      if (fetchError) {
        console.error("Error fetching church data:", fetchError);
        return { success: false, error: fetchError.message };
      }

      if (!churchData) {
        return { success: false, error: "Church not found" };
      }

      // If name changed, update Posts table and image name
      if (oldChurchName !== newChurchName) {
        console.log(
          `Updating Posts: changing churchName from "${oldChurchName}" to "${newChurchName}"`
        );

        // Get all posts with the old church name
        const { data: posts, error: postsError } = await (supabase as any)
          .from("posts")
          .select("id")
          .eq("post_id", oldChurchName);

        if (postsError) {
          console.error("Error fetching posts:", postsError);
          return { success: false, error: postsError.message };
        }

        // Update all posts with the new church name
        if (posts && posts.length > 0) {
          const postIds = posts.map((post: any) => post.id);
          const { error: updatePostsError } = await (supabase as any)
            .from("posts")
            .update({ post_id: newChurchName })
            .in("id", postIds);

          if (updatePostsError) {
            console.error("Error updating posts:", updatePostsError);
            return { success: false, error: updatePostsError.message };
          }

          console.log(`Updated ${posts.length} posts with new church name`);
        }

        // Update image name format: {personCreate}_{newChurchName}_church.jpg
        if (churchData.imagesName) {
          const personCreate = churchData.personCreate;
          // Sanitize new church name (replace non-alphanumeric with underscore)
          const sanitizedChurchName = newChurchName.replace(
            /[^a-zA-Z0-9]/g,
            "_"
          );
          const newImagesName = `${personCreate}_${sanitizedChurchName}_church.jpg`;

          // Rename the file in storage if it exists
          const bucketName = "tanyapendeta bucket";
          const oldFilePath = `church_images/${churchData.imagesName}`;
          const newFilePath = `church_images/${newImagesName}`;

          try {
            // Check if old file exists
            const { data: exists } = await supabase.storage
              .from(bucketName)
              .exists(oldFilePath);

            if (exists) {
              // Copy the file to new location
              const { data: fileData, error: readError } =
                await supabase.storage.from(bucketName).download(oldFilePath);

              if (!readError && fileData) {
                // Upload with new name
                const { error: uploadError } = await supabase.storage
                  .from(bucketName)
                  .upload(newFilePath, fileData, {
                    cacheControl: "3600",
                    upsert: true,
                  });

                if (uploadError) {
                  console.error("Error uploading renamed file:", uploadError);
                  return {
                    success: false,
                    error: uploadError.message,
                  };
                }

                // Delete old file
                const { error: deleteError } = await supabase.storage
                  .from(bucketName)
                  .remove([oldFilePath]);

                if (deleteError) {
                  console.warn("Error deleting old file:", deleteError);
                  // Continue anyway as the new file was created
                }

                console.log(
                  `Renamed image from ${churchData.imagesName} to ${newImagesName}`
                );
              }
            }

            // Update the church record with new image name
            const updatePayload: any = {
              introduction,
              name: newChurchName,
              imagesName: newImagesName,
            };

            const { data, error } = await (supabase as any)
              .from("church")
              .update(updatePayload)
              .eq("name", oldChurchName);

            if (error) {
              console.error("Error updating church:", error.message);
              return { success: false, error: error.message };
            }

            return { success: true };
          } catch (storageError) {
            console.error("Error updating image in storage:", storageError);
            return {
              success: false,
              error:
                storageError instanceof Error
                  ? storageError.message
                  : "Error updating image",
            };
          }
        } else {
          // No image, just update name and introduction
          const updatePayload: any = {
            introduction,
            name: newChurchName,
          };

          const { data, error } = await (supabase as any)
            .from("church")
            .update(updatePayload)
            .eq("name", oldChurchName);

          if (error) {
            console.error("Error updating church:", error.message);
            return { success: false, error: error.message };
          }

          return { success: true };
        }
      } else {
        // Name didn't change, just update introduction
        const updatePayload: any = { introduction };

        const { data, error } = await (supabase as any)
          .from("church")
          .update(updatePayload)
          .eq("name", oldChurchName);

        if (error) {
          console.error("Error updating church:", error.message);
          return { success: false, error: error.message };
        }

        return { success: true };
      }
    } catch (err) {
      console.error("Exception updating church:", err);
      return {
        success: false,
        error: err instanceof Error ? err.message : "Unknown error",
      };
    }
  }

  /**
   * Accepts a pending user to join the church
   * Removes user from userPending and adds to userJoin
   */
  public async acceptUser(
    churchName: string,
    username: string
  ): Promise<{ success: boolean; error?: string }> {
    try {
      // Get current church data
      const { data: churchData, error: fetchError } = await (supabase as any)
        .from("church")
        .select("userJoin, userPending")
        .eq("name", churchName)
        .maybeSingle();

      if (fetchError) {
        console.error("Error fetching church data:", fetchError);
        return { success: false, error: fetchError.message };
      }

      if (!churchData) {
        return { success: false, error: "Church not found" };
      }

      // Parse userJoin and userPending arrays
      let userJoin: string[] = [];
      let userPending: string[] = [];

      if (churchData.userJoin) {
        try {
          userJoin =
            typeof churchData.userJoin === "string"
              ? JSON.parse(churchData.userJoin)
              : churchData.userJoin;
          if (!Array.isArray(userJoin)) userJoin = [];
        } catch (e) {
          console.warn("Error parsing userJoin:", e);
          userJoin = [];
        }
      }

      if (churchData.userPending) {
        try {
          userPending =
            typeof churchData.userPending === "string"
              ? JSON.parse(churchData.userPending)
              : churchData.userPending;
          if (!Array.isArray(userPending)) userPending = [];
        } catch (e) {
          console.warn("Error parsing userPending:", e);
          userPending = [];
        }
      }

      // Check if user is in pending
      if (!userPending.includes(username)) {
        return { success: false, error: "User is not in pending list" };
      }

      // Remove from pending and add to join (if not already there)
      userPending = userPending.filter((user) => user !== username);
      if (!userJoin.includes(username)) {
        userJoin.push(username);
      }

      // Update the church record
      const { error: updateError } = await (supabase as any)
        .from("church")
        .update({
          userJoin: JSON.stringify(userJoin),
          userPending: JSON.stringify(userPending),
        })
        .eq("name", churchName);

      if (updateError) {
        console.error("Error updating church:", updateError);
        return { success: false, error: updateError.message };
      }

      console.log(
        `Successfully accepted user ${username} to church ${churchName}`
      );
      return { success: true };
    } catch (err) {
      console.error("Exception accepting user:", err);
      return {
        success: false,
        error: err instanceof Error ? err.message : "Unknown error",
      };
    }
  }

  /**
   * Removes a member from the church
   * Removes user from userJoin array
   */
  public async removeMember(
    churchName: string,
    username: string
  ): Promise<{ success: boolean; error?: string }> {
    try {
      // Get current church data
      const { data: churchData, error: fetchError } = await (supabase as any)
        .from("church")
        .select("userJoin")
        .eq("name", churchName)
        .maybeSingle();

      if (fetchError) {
        console.error("Error fetching church data:", fetchError);
        return { success: false, error: fetchError.message };
      }

      if (!churchData) {
        return { success: false, error: "Church not found" };
      }

      // Parse userJoin array
      let userJoin: string[] = [];

      if (churchData.userJoin) {
        try {
          userJoin =
            typeof churchData.userJoin === "string"
              ? JSON.parse(churchData.userJoin)
              : churchData.userJoin;
          if (!Array.isArray(userJoin)) userJoin = [];
        } catch (e) {
          console.warn("Error parsing userJoin:", e);
          userJoin = [];
        }
      }

      // Check if user is in userJoin
      if (!userJoin.includes(username)) {
        return { success: false, error: "User is not a member of this church" };
      }

      // Remove user from userJoin
      userJoin = userJoin.filter((user) => user !== username);

      // Update the church record
      const { error: updateError } = await (supabase as any)
        .from("church")
        .update({
          userJoin: JSON.stringify(userJoin),
        })
        .eq("name", churchName);

      if (updateError) {
        console.error("Error updating church:", updateError);
        return { success: false, error: updateError.message };
      }

      console.log(
        `Successfully removed user ${username} from church ${churchName}`
      );
      return { success: true };
    } catch (err) {
      console.error("Exception removing member:", err);
      return {
        success: false,
        error: err instanceof Error ? err.message : "Unknown error",
      };
    }
  }

  /**
   * Deletes a church and all related posts
   */
  public async deleteChurch(
    churchName: string
  ): Promise<{ success: boolean; error?: string }> {
    try {
      // First, delete all posts with this church name
      console.log(`Deleting posts for church: ${churchName}`);

      const { data: posts, error: postsError } = await (supabase as any)
        .from("posts")
        .select("id")
        .eq("post_id", churchName);

      if (postsError) {
        console.error("Error fetching posts:", postsError);
        return { success: false, error: postsError.message };
      }

      // Delete all posts
      if (posts && posts.length > 0) {
        const postIds = posts.map((post: any) => post.id);
        const { error: deletePostsError } = await (supabase as any)
          .from("posts")
          .delete()
          .in("id", postIds);

        if (deletePostsError) {
          console.error("Error deleting posts:", deletePostsError);
          return { success: false, error: deletePostsError.message };
        }

        console.log(`Deleted ${posts.length} posts for church: ${churchName}`);
      }

      // Then delete the church
      const { error: deleteChurchError } = await (supabase as any)
        .from("church")
        .delete()
        .eq("name", churchName);

      if (deleteChurchError) {
        console.error("Error deleting church:", deleteChurchError);
        return { success: false, error: deleteChurchError.message };
      }

      console.log(`Successfully deleted church: ${churchName}`);
      return { success: true };
    } catch (err) {
      console.error("Exception deleting church:", err);
      return {
        success: false,
        error: err instanceof Error ? err.message : "Unknown error",
      };
    }
  }
}

export default new AxiosWidgetChurch();
